module.exports = __webpack_public_path__ + "img/virtual.3db9e6c7.png";